import React, { useState } from 'react'
import { graphql } from 'gatsby'

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'

import PDPHero from '../../components/pdp-hero'
import FoldNav from '../../components/fold-nav'
import BrowseCategories from '../../components/browse-categories'
import TestimonialSlider from '../../components/testimonial-slider-lo-fly-dirt'
import TryItFree from '../../components/try-it-free'
import CriteoProduct from '../../criteo/product'

import downloadWhite from '../../images/svgs/download-icon-white.svg'

import bg1 from '../../images/lo-fly-dirt/bg-1.png'
import bg2 from '../../images/lo-fly-dirt/bg-2.jpg'
import bg3 from '../../images/lo-fly-dirt/bg-3.png'

import bg5 from '../../images/lo-fly-dirt/bg-5.png'
import bg6 from '../../images/lo-fly-dirt/bg-6.jpg'

import gif from '../../images/lo-fly-dirt/lo-fly-dirt-1000-987.gif'

import image1 from '../../images/lo-fly-dirt/image-1.png'
import image2 from '../../images/lo-fly-dirt/image-2.png'
import image3 from '../../images/lo-fly-dirt/image-3.png'
import image4 from '../../images/lo-fly-dirt/image-4.png'

import led from '../../images/lo-fly-dirt/led.png'
import mode1 from '../../images/lo-fly-dirt/msxii.png'
import mode2 from '../../images/lo-fly-dirt/60.png'
import mode3 from '../../images/lo-fly-dirt/404f.png'
import mode4 from '../../images/lo-fly-dirt/404v.png'
import mode5 from '../../images/lo-fly-dirt/1200.png'
import mode6 from '../../images/lo-fly-dirt/8bit.png'
import mode7 from '../../images/lo-fly-dirt/sk5.png'

import logo from '../../images/lo-fly-dirt/logo-1.png'
import quote from '../../images/lo-fly-dirt/quote-blue.png'

import trailer from '../../images/lo-fly-dirt/trailer.png'

import '../../styles/product-page/lo-fly-dirt.scss'

export const query = graphql`
    query ProductPageQuery {
        product(sku: {eq: "XSLFD"}){
            id
            productId
            product_name
            short_description
            description
            sku
            slug
            badge            
            cdnLinkMac
            cdnLinkWindows
            releasedDate
            rawHTMLContent
            shop_categories {
                name
                slug
            }
            childrenFile {
                childImageSharp {
                    gatsbyImageData
                }
            }
            thumbnails: childrenFile {
                childImageSharp {
                    gatsbyImageData(width: 96, height: 64)
                }
            }
            includes {
                slug
                shop_categories {
                    slug
                }
                product_name
            }
            requires {
                product_name
                shop_categories {
                    slug
                }
                slug
            }
            works_with {
                id
                image
                name
                path
            }
        }
    }
`

export function Head(props) {
    const { data: { product } } = props
    const { product_name } = product
    return (
        <>
            <title>{product_name}</title>
            <CriteoProduct product={product} />
        </>
    )
}

export default function Product(props) {
    const { data } = props
    const { product } = data
    const [modalShow, setModalShow] = useState(false)
    const [modal2Show, setModal2Show] = useState(false)

    return (
        <div id="lo-fly">
            <PDPHero product={product} />
            <FoldNav product={product} showNav={false} />

            {/* VINTAGE SOUNDS */}
            <Container fluid className="p-0" style={{
                backgroundImage: `url(${bg1})`,
                backgroundSize:'cover'
            }}>

            <Container className=' py-5'>  
                <Row className='pt-5 justify-content-center'>
                    <Col lg={10} md className='text-white text-center px-5'>
                        <p style={{fontWeight:800}}>LO-FLY DIRT</p>
                        <h3 className="changeling-neo p-md-3 mx-md-5" style={{fontSize:42,color:'#FFF',textTransform:'uppercase'}}>Vintage Sounds For <br></br>
                        <span style={{fontSize:42,color:'#8FE2F6',textTransform:'uppercase'}}>The Modern Musician</span></h3>
                    </Col>
                </Row>

                <Row className='py-5 text-white justify-content-center align-items-center'>
                    <Col lg={5} className='text-center p-5'>
                        <img className="mw-100" src={gif}></img>
                    </Col>
                    <Col lg={5} className='p-3 text-left'>
                        <p>From lo-fi saturation and filtering to 8-bit gaming console mangling and vinyl noise effects, Lo-Fly Dirt brings out the sought-after textures and inherent tones of your audio sources. One twist of the classic character knob warms, lifts, and adds the classic lo-fi element to your sound design and production process, paying homage to vintage synths and audio hardware.</p>
                        <a onClick={() => setModalShow(true)} className="border border-white d-inline-block p-2 fw-bold ff-primary text-white ease-5 demo-btn-transition mt-5" style={{ borderRadius: 36 }} href="#sound">
                            <img src={trailer} alt='' className='mw-100' style={{width:36}} />
                            &nbsp;WATCH THE TRAILER
                        </a>
                        <Modal
                            show={modalShow}
                            onHide={() => setModalShow(false)}
                            size="xl"
                            aria-labelledby="contained-modal-title-vcenter"
                            centered
                        >
                            <Modal.Body className='p-0'>
                                <iframe
                                    width='100%'
                                    height='720'
                                    src="https://www.youtube.com/embed/PXjf5Gx1T7E"
                                    title="Introducing Lo-Fly Dirt"
                                    frameborder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    referrerpolicy="strict-origin-when-cross-origin"
                                    allowFullscreen
                                ></iframe>
                            </Modal.Body>
                        </Modal>
                    </Col>
                </Row>
            </Container>
            </Container>

            {/* TIME MACHINE */}
            <Container fluid style={{
                backgroundImage: `url(${bg2})`,
                backgroundSize:'cover'
                }}>
                <Container className='py-5'>
                    <Row className='justify-content-center py-5'>
                        <Col md={10} className='px-5 text-center text-white'>
                            <img className="mw-100" src={logo}></img>
                            <img className="mw-100 py-5" src={image1}></img>
                            <h2 className='pb-3 changeling-neo' style={{color:'#FB3D23',fontSize:44,lineHeight:'40px',textTransform:'uppercase'}}>A TIME MACHINE OF SOUND</h2>
                            <p>Now available for desktop and MPC users, the Lo-Fly Dirt Plugin is not just a tool but a journey through the history of sound, reimagined for the modern producer. Experience unparalleled creativity and inject your tracks with the soulful dirt of yesteryears, all while enjoying the cutting-edge technology of today. Welcome to the future of music production with Lo-Fly Dirt.</p>

                        </Col>
                    </Row>
                </Container>     
            </Container>

            {/* MICHAEL SIMPSON */}
            <Container fluid style={{
                backgroundColor: `#271449`,
                backgroundSize:'cover'
                }}>
                <Container className='py-5'>
                    <Row className='justify-content-center align-items-center py-5'>
                        <Col md={5} lg={3} className='mb-5 px-5 text-center text-white position-relative'>
                            <img className="mw-100" src={image2}></img>
                            <img className="mw-100" style={{
                                                position: 'absolute',
                                                bottom: -30,
                                                left: '50%',
                                                transform: 'translateX(-50%)'}} src={quote}></img>
                        </Col>
                        <Col md={7} className='px-5 text-left text-white'>
                            <p className="oswald" style={{fontSize:32,fontWeight:600,textTransform:'uppercase',color:'#8FE2F6'}}>Michael Simpson</p>
                            <p>“Lo-Fly Dirt was initially created as an in-house tool for the MSXII Sound Design conglomerate. Coming from the era of distinct sounding hardware, the tools we utilized offered a sound that was unmatched in audio processing in our space. LFD was meant to replicate our favorite things about the characteristics of that old music production hardware! We are pleased to launch it more broadly on the MPC platform as well as desktop in partnership with our friends at AIR & Akai.”</p>
                            <p style={{fontSize:14,fontWeight:700}}>Michael Simpson, founder & CEO of MSXII Sound Design</p>
                        </Col>
                    </Row>
                </Container>     
            </Container>

            {/* MODES */}                       
            <Container fluid style={{
                backgroundColor:'#fff',
                backgroundImage: `url(${bg3})`,
                backgroundSize:'cover'
                }}>
                <Container className='py-5 text-white'>
                    <Row className='text-center justify-content-center pt-lg-5'>
                        <Col md={8}>
                            <h3 className="changeling-neo p-md-3 mx-md-5" style={{fontSize:42,color:'#FFF',textTransform:'uppercase'}}>7 SPECIALIZED  <br></br>
                            <span style={{fontSize:42,color:'#8FE2F6',textTransform:'uppercase'}}>CHARACTER MODES</span></h3>
                            <p>Featuring an array of meticulously designed modes, each offering a unique sonic palette, the Lo-Fly Dirt Plugin caters to every aspect of your creative needs.</p>
                        </Col>
                    </Row>
                    <Row className='text-center justify-content-center py-lg-5'>
                        <Col className='lo-fly-mode' sm={6} md={4} lg={3}>
                            <div className='inner-mode'>
                                <img src={led} alt="" className="mw-100 py-3"/><br></br>
                                <img src={mode1} alt="" className="mw-100 py-3"/>
                                <p className="oswald" style={{fontWeight:300,fontSize:32,textTransform:'uppercase'}}><span style={{fontWeight:600,color:'#989898'}}>MSXII:</span> DEFAULT<br></br>saturation</p>
                                <p>A nod to the original MSXII Lo-Fly Dirt app, this essential preset introduces subtle character to your input sound. Simple saturation and compression are added to the overall sound, bringing out the unique tones and textures of your source audio.</p>
                            </div>
                        </Col>
                        <Col className='lo-fly-mode' sm={6} md={4} lg={3}>
                            <div className='inner-mode'>
                                <img src={led} alt="" className="mw-100 py-3"/><br></br>
                                <img src={mode2} alt="" className="mw-100 py-3"/>
                                <p className="oswald" style={{fontWeight:300,fontSize:32,textTransform:'uppercase'}}><span style={{fontWeight:600,color:'#E1E1E1'}}>60:</span> MPC60 style lo-fi<br></br>saturation</p>
                                <p>This preset mode is based on selected characteristics of early sampling workflows using the iconic drum/sampler machine. Activating this button invites 12-bit nostalgia, offering tasteful saturation, light compression, and a more rounded high end.</p>
                            </div>
                        </Col>
                        <Col className='lo-fly-mode' sm={6} md={4} lg={3}>
                            <div className='inner-mode'>
                                <img src={led} alt="" className="mw-100 py-3"/><br></br>
                                <img src={mode3} alt="" className="mw-100 py-3"/>
                                <p className="oswald" style={{fontWeight:300,fontSize:32,textTransform:'uppercase'}}><span style={{fontWeight:600,color:'#DE9350'}}>404 (F):</span> Low-pass<br></br>filtering</p>
                                <p>This mode adds subtle low-pass filtering to the input signal, while applying filtering at 12db per octave at 11.6Khz up to 200Hz. It adds dirt and boosts the signal with minimal gain, contributing small amounts of bit rate reduction.</p>
                            </div>
                        </Col>
                        <Col className='lo-fly-mode' sm={6} md={4} lg={3}>
                            <div className='inner-mode'>
                                <img src={led} alt="" className="mw-100 py-3"/><br></br>
                                <img src={mode4} alt="" className="mw-100 py-3"/>
                                <p className="oswald" style={{fontWeight:300,fontSize:32,textTransform:'uppercase'}}><span style={{fontWeight:600,color:'#633D62'}}>404 (V):</span> Vinyl<br></br>emulation</p>
                                <p>This mode adds vinyl simulation into the Lo-Fly Dirt mix. Easily introduce vinyl noise to the overall mix and use the wet/dry function to adjust the intensity, bringing subtle warmth, buzz, and crunchy texture elements to your sound.</p>
                            </div>
                        </Col>
                        <Col className='lo-fly-mode' sm={6} md={4} lg={3}>
                            <div className='inner-mode'>
                                <img src={led} alt="" className="mw-100 py-3"/><br></br>
                                <img src={mode5} alt="" className="mw-100 py-3"/>
                                <p className="oswald" style={{fontWeight:300,fontSize:32,textTransform:'uppercase'}}><span style={{fontWeight:600,color:'#7C7C7C'}}>1200:</span> SP1200 style<br></br>saturation</p>
                                <p>Built around the iconic drum machine, this mode adds instant character to signal. A beefier variation of the 60 Mode, it brings classic 12-bit goodness by default while allowing for amplification of the overall dirt by boosting the low-mid frequencies.</p>
                            </div>
                        </Col>
                        <Col className='lo-fly-mode' sm={6} md={4} lg={3}>
                            <div className='inner-mode'>
                                <img src={led} alt="" className="mw-100 py-3"/><br></br>
                                <img src={mode6} alt="" className="mw-100 py-3"/>
                                <p className="oswald" style={{fontWeight:300,fontSize:32,textTransform:'uppercase'}}><span style={{fontWeight:600,color:'#CD0E18'}}>8-BIT</span> console<br></br>emulation</p>
                                <p>This mode returns to the classic sound of a legendary gaming console. 8-BIT adds elements of punch and grit to the incoming audio signal, blended with 8-bit artifacts allowing for bold, nostalgic, lo-fi results in your mix.</p>
                            </div>
                        </Col>
                        <Col className='lo-fly-mode' sm={6} md={4} lg={3}>
                            <div className='inner-mode'>
                                <img src={led} alt="" className="mw-100 py-3"/><br></br>
                                <img src={mode7} alt="" className="mw-100 py-3"/>
                                <p className="oswald" style={{fontWeight:300,fontSize:32,textTransform:'uppercase'}}><span style={{fontWeight:600,color:'#7F99C7'}}>SK-5:</span> 8-Bit<br></br>with a Twist</p>
                                <p>Experience extreme lo-fi emulation built off the classic 8-bit sound in this mode, which introduces high-pass filtering and enhanced punch. Moving from dry to wet activates instant dirt with a high-pass filter cutoff at 300Hz.</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Container>

            <TestimonialSlider />

            {/* WALKTHROUGH */}
            <Container fluid style={{
                backgroundColor:'#fff',
                backgroundImage: `url(${bg5})`,
                backgroundSize:'cover'
                }}>
                <Container className='p-5'>
                    <Row className='align-items-center pt-5 text-white text-center'>
                        <Col>
                            <h2 className='pb-3 changeling-neo d-none d-lg-block' style={{fontSize:44,lineHeight:'40px',textTransform:'uppercase'}}>WALKTHROUGH VIDEO</h2>
                            <h2 className='pb-3 changeling-neo d-lg-none' style={{fontSize:30,lineHeight:'40px',textTransform:'uppercase'}}>WALKTHROUGH VIDEO</h2>
                            <p>Take a deep dive into the sound and character what makes Lo-Fly Dirt an essential audio effect.</p>
                        </Col>
                    </Row>
                    <Row className='justify-content-center py-5 text-white text-center'>
                        <Col lg={10} className='text-center'>
                            <Button onClick={() => setModal2Show(true)} className='bg-transparent border-0 position-relative hover-fade'>
                                <img src={image3} alt="" className='mw-100 hover-bg ease-5' />
                                <span className='position-absolute top-50 start-50 translate-middle hover-play ease-5 oswald p-2' style={{color:'#000',fontSize:18,fontWeight:600,borderRadius:40,background:'rgb(255,255,255,1'}} ><img src={trailer} alt="" style={{width:44}}/> WATCH THE WALKTHROUGH </span>
                            </Button>
                            <Modal
                                show={modal2Show}
                                onHide={() => setModal2Show(false)}
                                size="xl"
                                aria-labelledby="contained-modal-title-vcenter"
                                centered
                            >
                                <Modal.Body className='p-0'>
                                    <iframe
                                        width='100%'
                                        height='720'
                                        src="https://www.youtube.com/embed/_SwqUhzzQPQ"
                                        title="Lo-Fly Dirt Walkthrough"
                                        frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        referrerpolicy="strict-origin-when-cross-origin"
                                        allowFullscreen
                                    ></iframe>
                                </Modal.Body>
                            </Modal>
                        </Col>
                    </Row>
                </Container>
            </Container>

            {/* SOUNDCLOUD */}
            <Container fluid className='position-relative py-5' style={{
                backgroundImage: `url(${bg6})`,
                backgroundSize:'cover'
                }}>
                <Container className='py-3'>
                    <Row className='align-items-center justify-content-center text-center'>
                        <Col md={8}>
                           
                            <h3 className="changeling-neo p-md-3 mx-md-5" style={{fontSize:42,color:'#8FE2F6',textTransform:'uppercase'}}>Hear Lo-Fly Dirt<br></br>
                            <span style={{fontSize:42,color:'#FFF',textTransform:'uppercase'}}>in action</span></h3>

                        </Col>
                        <Col md={12}>
                            <div dangerouslySetInnerHTML={{ __html: `<iframe width="100%" height="450" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/2007573432&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"></iframe><div style="font-size: 10px; color: #cccccc;line-break: anywhere;word-break: normal;overflow: hidden;white-space: nowrap;text-overflow: ellipsis; font-family: Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif;font-weight: 100;"></div>` }} />
                        </Col>
                    </Row>

                </Container>
            </Container>

            {/* TRY IT FREE */}
            <Container fluid className='bg-black text-white p-0'>
                <img src={image4} className="w-100" />
                <Container className='py-md-5 py-5'>
                    <Row className='row align-items-center  text-center pb-5'>
                        <div id="laptop" className='col-12'>
                            <h3 className="changeling-neo text-white" style={{fontSize:52}}>TRY IT FREE</h3>
                            <p className="pb-3"><strong>Download the 10 day trial of Lo-Fly Dirt desktop: VST, AU, or AAX</strong></p>
                            <TryItFree
                            product={product}
                            className='border border-white text-white inline-flex-center gap-1'
                            style={{
                                height: 40,
                                width: 160,
                            }}
                        >
                            <img src={downloadWhite} alt='' height={22} width={22} />
                            DOWNLOAD TRIAL
                        </TryItFree>
                        </div>
                    </Row>
                </Container>
            </Container>

            {/* SYSTEM REQUIREMENTS */}
            <Container fluid id="system-requirements" className='position-relative py-5' style={{backgroundColor:"#262626"}}>
                <Container>
                    <Row>
                        <Col>
                            <h3 className='mb-4 text-yellow text-uppercase changeling-neo' style={{fontSize:28}}>System Requirements</h3>
                            <p className='text-white mb-5'>Lo-Fly Dirt is designed to support VST 2 and VST3 Plugin hosts as well as full support for MPC standalone and desktop systems running version 2.15.1, 3.4.1 (or newer). This software requires an internet connection for authorization. You will need to install Akai's MPC desktop software version 2.15.1, 3.4.1 or higher to use desktop versions of the plugins.</p>
                            <table className="table border text-white dark-stripes mb-5">
                                <thead>
                                    <tr>
                                        <th>Windows</th>
                                        <th>MAC</th>
                                        <th>MPC/Force Standalone Compatibility</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Windows 10, 11</td>
                                        <td>macOS 12 - 15</td>
                                        <td>Lo Fly Dirt is designed to run on standalone MPC systems running 2.15.1, 3.4.1 (or newer) including:</td>
                                    </tr>
                                    <tr>
                                        <td>105 MB free disk space</td>
                                        <td>210 MB free disk space</td>
                                        <td>MPC One</td>
                                    </tr>
                                    <tr>
                                        <td>4GB RAM (8GB recommended)</td>
                                        <td>4GB RAM (8GB recommended)</td>
                                        <td>MPC Live</td>
                                    </tr>
                                    <tr>
                                        <td>Dual Core 2.5GHz CPU</td>
                                        <td>Dual Core 2.5GHz CPU</td>
                                        <td>MPC Live II</td>
                                    </tr>
                                    <tr>
                                        <td>VST 2/3 compatible host</td>
                                        <td>VST 2/3 Plugin compatible host</td>
                                        <td>MPC X</td>
                                    </tr>
                                    <tr>
                                        <td>AAX plugin compatible host</td>
                                        <td>AAX plugin compatible host</td>
                                        <td>MPC Key 61</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td>AU plugin compatible host</td>
                                        <td>MPC One +</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td>MPC Key 37</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td>FORCE</td>
                                    </tr>
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                </Container>
            </Container>

            <BrowseCategories />
        </div>
    )
}